/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import Loader from 'components/atoms/loader';
import Pagination from 'components/atoms/pagination';
import { JuridicoFacilState } from 'store/modules/juridico_facil_store/types';
import EmptyResult from 'components/atoms/empty_result';
import { Container } from './styles';

interface ListAcervoProps {
  word: string;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  currentPage: number;
}

const ListAcervo = (props: ListAcervoProps) => {
  const { word, setCurrentPage, currentPage } = props;

  const { juridico, request } = useSelector<ApplicationState, JuridicoFacilState>(
    (state) => state.session.juridico,
  );

  const paginate = (currentPage = 1) => {
    if (currentPage) {
      setCurrentPage(currentPage);
    }
  };

  return (
    <Container>
      {request?.search?.loading ? (
        <Loader />
      ) : (
        juridico?.acervo?.map((acervo) => (
          <div className="card mt-4">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <nav>
                    <ol className="breadcrumb breadcrumb-custom">
                      <li className="breadcrumb-item">
                        <a href="#" data-abc="true">
                          <strong>{acervo.tipo}</strong>
                          {!!acervo.court && (
                            <span className="badge badge-light ml-2">
                              {acervo.court.replace('_', '-')}
                            </span>
                          )}
                        </a>
                      </li>
                      <li className="breadcrumb-item">
                        <a href="#" data-abc="true">
                          {acervo.area}
                        </a>
                      </li>
                      {!!acervo.tema && (
                        <li className="breadcrumb-item">
                          <a href="#" data-abc="true">
                            {acervo.tema}
                          </a>
                        </li>
                      )}
                      {!!acervo.subtema && (
                        <li className="breadcrumb-item">
                          <a href="#" data-abc="true">
                            {acervo.subtema}
                          </a>
                        </li>
                      )}
                    </ol>
                  </nav>
                </div>
                <div className="col-md ml-2">
                  <a
                    href={`/juridico/show/${acervo.id}${
                      acervo.fonte ? `?fonte=${acervo.fonte}` : ''
                    }`}
                    className="link_acervo"
                    dangerouslySetInnerHTML={{
                      __html: acervo.enunciado.replace(
                        new RegExp(`(${word})`, 'gi'),
                        '<span class="badge badge-warning">$1</span>',
                      ),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))
      )}
      {request?.search?.loaded && juridico?.acervo?.length === 0 && (
        <EmptyResult
          title="Desculpe!"
          description="Ops, nada encontrado! Tente pesquisar com outra palavra-chave."
        />
      )}
      {juridico?.acervo && (
        <div className="row d-print-none mt-3">
          <div className="col-md-12 px-4 mb-5">
            <Pagination
              postsPerPage={10}
              totalPosts={juridico?.search_total_page}
              paginate={paginate}
              currentPage={currentPage}
              firstAndLastPage
            />
          </div>
        </div>
      )}
      <div />
    </Container>
  );
};

export default ListAcervo;
